import { api } from "../lib/api.js";

interface App {
  id: string;
  name: string;
  slug: string;
  status: string;
}

export async function lsCommand(): Promise<void> {
  const res = await api.get("/v1/apps");
  if (!res.ok) {
    console.error("Failed to list apps.");
    process.exit(1);
  }

  const payload = (await res.json()) as { apps: App[] } | App[];
  const apps = Array.isArray(payload) ? payload : payload.apps;

  if (apps.length === 0) {
    console.log("No apps deployed yet.");
    return;
  }

  const nameWidth = Math.max(4, ...apps.map((a) => a.name.length));
  const slugWidth = Math.max(4, ...apps.map((a) => a.slug.length));

  console.log(
    `${"Name".padEnd(nameWidth)}  ${"Slug".padEnd(slugWidth)}  ${"Status".padEnd(8)}  URL`
  );
  console.log(
    `${"─".repeat(nameWidth)}  ${"─".repeat(slugWidth)}  ${"─".repeat(8)}  ${"─".repeat(30)}`
  );

  for (const app of apps) {
    const url = `https://${app.slug}.apps.clawnify.com`;
    console.log(
      `${app.name.padEnd(nameWidth)}  ${app.slug.padEnd(slugWidth)}  ${app.status.padEnd(8)}  ${url}`
    );
  }
}
